<div class="polling-status-container" *ngIf="currentStatus && isPolling">
  <div class="status-card">
    <div class="status-header">
      <mat-icon class="status-icon spinning">sync</mat-icon>
      <span class="status-text">{{ dynamicStatusText }}</span>
    </div>

    <div class="progress-percentage" *ngIf="progressPercentage > 0">
      <span class="percentage-text">{{ progressPercentage }}% Complete</span>
    </div>

    <div class="status-details">
      <div class="detail-row">
        <span class="detail-label">Time Elapsed:</span>
        <span class="detail-value">{{ formatElapsedTime(totalElapsedSeconds) }}</span>
      </div>

      <div class="detail-row" *ngIf="estimatedTimeRemaining">
        <span class="detail-label">Estimated Time Remaining:</span>
        <span class="detail-value">{{ estimatedTimeRemaining }}</span>
      </div>
    </div>

    <div class="progress-bar">
      <mat-progress-bar 
        [mode]="progressPercentage > 0 ? 'determinate' : 'indeterminate'" 
        [value]="progressPercentage" 
        color="accent">
      </mat-progress-bar>
    </div>
  </div>
</div>

<!-- Timeout Status -->
<div class="polling-status-container" *ngIf="currentStatus && isTimeout">
  <div class="status-card status-card--timeout">
    <div class="status-header">
      <mat-icon class="status-icon">schedule</mat-icon>
      <span class="status-text">Request timed out</span>
    </div>

    <div class="status-message">
      <p>Your request is still processing in the background.</p>
      <p>You can find the response in your <strong>History</strong> once it's complete.</p>
    </div>
  </div>
</div>

<!-- Error Status -->
<div class="polling-status-container" *ngIf="currentStatus && isError">
  <div class="status-card status-card--error">
    <div class="status-header">
      <mat-icon class="status-icon">error</mat-icon>
      <span class="status-text">Processing error</span>
    </div>

    <div class="status-message">
      <p>There was an issue processing your request.</p>
      <p>Please try again or check your <strong>History</strong> for any completed responses.</p>
    </div>
  </div>
</div>